export default "__VITE_ASSET__Ds0zlu0i__"